export const getPagePathBySlug = (slug: string) => {
  // Strip all leading slashes to avoid malformed paths (e.g. "//about" → "/about")
  return `/${slug.replace(/^\/+/, '')}`
}

export const getMenuItemPathBySlug = (slug: string) => {
  return `/menu/${slug}`
}

export const getLocationPathBySlug = (slug: string) => {
  return `/locations/${slug}`
}

export const getBlogPostPathBySlug = (slug: string) => {
  return `/blog/${slug}`
}
